import { format, isValid, parse, subHours } from "date-fns";

const PLACEMENT_REFERENCE_DATE = new Date(2000, 0, 1);

export const SUNSET_LINE_OFFSET_HOURS = 2;

export function getSunsetLinePlacementTime(sunset: unknown): string | undefined {
  if (typeof sunset !== "string" || sunset.trim() === "") {
    return undefined;
  }
  const trimmed = sunset.trim();
  const parsedHH = parse(trimmed, "HH:mm", PLACEMENT_REFERENCE_DATE);
  if (isValid(parsedHH)) {
    return format(subHours(parsedHH, SUNSET_LINE_OFFSET_HOURS), "HH:mm");
  }
  const parsedH = parse(trimmed, "H:mm", PLACEMENT_REFERENCE_DATE);
  if (!isValid(parsedH)) {
    return undefined;
  }
  return format(subHours(parsedH, SUNSET_LINE_OFFSET_HOURS), "HH:mm");
}
